export default {
    search: 'Paieška',
    enter_the_city: 'Įveskite miestą',
    to_download: 'Parsisiųsti',
    make_an_appointment: 'PASITEIRAUTI',
    only_with: 'Tik iš',
    calculate_route: 'Apskaičiuokite maršrutą',
    e_conference: 'E-konzultacija',
    safe_appointment: 'Saugus apsilankymas salone'

}
